"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentWidth = exports.getColumnWidths = exports.portalLink = exports.letterLink = exports.getColumnText = exports.formatTimeMetaValue = exports.getNumberMetaValue = exports.getStringMetaValue = exports.getMeta = void 0;
var memoize = require("fast-memoize");
var moment = require("moment");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
exports.getMeta = memoize(function (row) {
    return row.customMeta.reduce(function (acc, meta) {
        acc.set(meta.identifier, meta);
        return acc;
    }, new Map());
});
var getStringMetaValue = function (name, meta) {
    var _a = (meta.get(name) || {}).value, value = _a === void 0 ? undefined : _a;
    if (typeof value === 'string')
        return value;
};
exports.getStringMetaValue = getStringMetaValue;
var getNumberMetaValue = function (name, meta) {
    var _a = (meta.get(name) || {}).value, value = _a === void 0 ? undefined : _a;
    if (typeof value === 'number')
        return value;
};
exports.getNumberMetaValue = getNumberMetaValue;
var formatTimeMetaValue = function (name, format, meta) {
    var value = (0, exports.getNumberMetaValue)(name, meta);
    if (typeof value === 'number')
        return moment(value).format(format);
};
exports.formatTimeMetaValue = formatTimeMetaValue;
var getColumnText = function (header, item) {
    var meta = (0, exports.getMeta)(item);
    switch (header) {
        case 'publishedAt':
            return (0, exports.formatTimeMetaValue)('published-at-meta', 'L LT', meta) || '-';
        case 'updatedAt':
            return ((0, exports.formatTimeMetaValue)('updated-at-meta', 'L LT', meta) ||
                (0, exports.formatTimeMetaValue)('added-meta', 'L LT', meta) ||
                '-');
        case 'status':
            var status = (0, exports.getStringMetaValue)('bid-status-meta', meta);
            return (0, translation_1.getLocalization)("additionalLettersView/row/status/".concat(status));
        case 'description':
            return (0, exports.getStringMetaValue)('description-meta', meta) || '-';
        default:
            return (item[header] || '').toString();
    }
};
exports.getColumnText = getColumnText;
var letterLink = function (selectedLanguage, briefcase, bid, letter) {
    return "/".concat(selectedLanguage, "/briefcase/").concat(briefcase.id, "/bid/").concat(bid.id, "/letter/").concat(letter.id);
};
exports.letterLink = letterLink;
var portalLink = function (selectedLanguage, bid, letter) { return "/".concat(selectedLanguage, "/bid/").concat(bid.id, "/letters/").concat(letter.id); };
exports.portalLink = portalLink;
exports.getColumnWidths = memoize(function (list, isMobile, headers) {
    var headerNames = headers;
    return headerNames
        .map(function (header) {
        var values = list.map(function (item) {
            return (0, text_1.calculateStringLength)((0, exports.getColumnText)(header, item).substr(0, 50));
        });
        values.unshift((0, text_1.calculateStringLength)((0, translation_1.getLocalization)("additionalLettersView/column/".concat(header)).toString()) + 42);
        return values.sort(function (a, b) { return (a > b ? -1 : 1); })[0];
    })
        .reduce(function (acc, length, index) {
        acc['__' + headerNames[index].replace(/-/g, '')] = length;
        return acc;
    }, {});
});
var getContentWidth = function (lengths) {
    var contentWidth = 0;
    contentWidth += 2 * 42;
    Object.keys(lengths).forEach(function (className, i) {
        var colwidth = Math.max(8, 4 + lengths[className] + 26); // convert to rem
        contentWidth += colwidth;
    });
    return contentWidth;
};
exports.getContentWidth = getContentWidth;
